import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { BiSolidUser } from "react-icons/bi";
import "./DocumentExpire.css";

const DocumentExpire = ({ data }) => {
  const [documentAlert] = useState(data);
  const navigate = useNavigate();

  const handleSearch = async (e, identify, relationUser) => {
    e.preventDefault();
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_SEARCH_USER_API}?id=${identify}&relation=${relationUser}`
      );
      if (res.data) {
        navigate("/informe", { state: res.data });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se encontró el usuario.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  const typeRisk = (alertUser) => {
    if (alertUser.risk === "Riesgo alto") {
      return <p className="riskhigh">Riesgo Alto</p>;
    }

    if (alertUser.risk === "Riesgo medio") {
      return <p className="riskmid">Riesgo Medio</p>;
    }

    if (alertUser.risk === "Riesgo bajo") {
      return <p className="risklow">Riesgo Bajo</p>;
    }
  };
  return (
    <div className="boxtableDocumentAlert">
      <table className="tableDocumentAlerts">
        <thead>
          <tr>
            <th className="tableDocumentHeader">Riesgo</th>
            <th className="tableDocumentHeader">Usuario</th>
            <th className="tableDocumentHeader">Dni / Cuit</th>
            <th className="tableDocumentHeader">Relacion con la Mutual</th>
            <th className="tableDocumentHeader">Tipo de Usuario</th>
            <th className="tableDocumentHeader">Archivo</th>
            <th className="tableDocumentHeader">Fecha de vencimiento</th>
            <th className="tableDocumentHeader">Actualizar</th>
          </tr>
        </thead>
        <tbody>
          {documentAlert.map((item, index) => {
            return (
              <tr key={index}>
                <td className="tableDocumentDataRisk">{typeRisk(item)}</td>
                <td className="tableDocumentData">{item.name}</td>
                <td className="tableDocumentData">{item.identify}</td>
                <td className="tableDocumentData">{item.relationUser}</td>
                <td className="tableDocumentData">{item.userType}</td>
                <td className="tableDocumentData">{item.entityType}</td>
                <td className="tableDocumentData">{item.expirationDate}</td>
                <td className="tableDocumentData">
                  <BiSolidUser
                    className="iconGrilla"
                    onClick={(e) =>
                      handleSearch(e, item.identify, item.relationUser)
                    }
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DocumentExpire;
